
import { TurretActor } from "./TurretActor";
import { GameVars } from "../../../GameVars";

export class TurretLevel extends Phaser.GameObjects.Container {

    private turret: TurretActor;

    constructor(scene: Phaser.Scene, turret: TurretActor) {

        super(scene);

        this.y = 22;

        this.turret = turret;
    }

    public update(): void {

        if (GameVars.paused || GameVars.semiPaused || GameVars.waveOver || GameVars.turretSelectedOn || this.turret.showLevel) {

            if (!this.visible) {
                this.visible = true;
            }

        } else {

            if (this.visible) {
                this.visible = false;
            }
        }
    }
}
